export const UPLOADS_SLICE_NAME = 'uploads';
